import { render } from "./GroupPopover.vue?vue&type=template&id=a0f1c706&scoped=true"
import script from "./GroupPopover.vue?vue&type=script&lang=js"
export * from "./GroupPopover.vue?vue&type=script&lang=js"

import "./GroupPopover.vue?vue&type=style&index=0&id=a0f1c706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f1c706"]])

export default __exports__